module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/CanceladoIcon.2d98332a.svg";